const DEFAULT_SYMBOL = '$';

/**
 * The class's constructor's defaults.
 * @type {Object}
 * @property {String} template
 * @property {Number} rate
 * @property {Boolean} forceRound
 * @property {Number} forceRoundFromAmount
 */
export const CURRENCY_DEFAULTS = {
    template: `${DEFAULT_SYMBOL}{{amount}}`,
    rate: 1,
    forceRound: false,
    forceRoundFromAmount: 100
};

/**
 * The `convert` method's defaults.
 * @type {Object}
 * @property {Boolean} commaSeparate
 * @property {Boolean} convertRate
 * @property {Boolean} forceRound
 * @property {String} thousandsSeparator
 * @property {String} decimalSeparator
 * @property {Boolean} asNumber
 */
export const CONVERTER_DEFAULTS = {
    commaSeparate: false,
    convertRate: true,
    forceRound: false,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    asNumber: false
};
